import { OrderResourceType } from '@returnmates/client-core/src/graphql/generated/api'

export const initialFormValues = {
  code: '',
  name: '',
  header: '',
  subHeader: '',
  desktopLogo: '',
  mobileLogo: '',
  offerExpiresOn: null,
  promoCode: '',
  schedulerLimit: null,
  isPaymentEnabled: false,
  isUploadEnabled: false,
  isOrderLookupEnabled: false,
  areTimeSlotsEnabled: false,
  isFirstPickupFree: false,
  isReadyCloudEnabled: false,
  readyCloudUrl: null,
  button: '',
  bccEmails: '',
  bulletHeader1: '',
  bulletHeader2: '',
  bulletHeader3: '',
  bulletSubHeader1: '',
  bulletSubHeader2: '',
  bulletSubHeader3: '',
  successHeaderDesktop: '',
  successHeaderMobile: '',
  successSubHeaderDesktop: '',
  successSubHeaderMobile: '',
  successButton: '',
  plpSuccessRedirectUrl: null,
  loadingTitle: '',
  labelUrl: '',
  isPromoEnabled: false,
  shippedPhrase: '',
  packageDescription: '',
  shareTitle: '',
  shareDescription: '',
  shareImage: '',
  headerColor: '',
  isDarkHeaderText: false,
  headerImageUrl: '',
  priceHubs: [],
  attributes: [],
  users: [],
  orderResource: OrderResourceType.RETURNMATES,
  orderExpire: 0,
  requiresReceiptTracking: false,
  isPkgEditingEnabled: true,
  isOrderBasedPickup: false,
  tpBanner: '',
  tpLogo: null,
  webhookUrl: '',
  webhookToken: '',
}
